export default __webpack_public_path__ + "static/media/AG.f3d0fc19.ico";